/*
 * @Author: Dom
 * @Date: 2022-06-03 17:26:03
 * @LastEditTime: 2022-06-03 18:56:42
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\store\loding.ts
 */
import {Mutation, Action} from 'vuex';
import {StoreModuleType} from '@/utils/store';

export interface StateType {
    loading: boolean;
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType,
    mutations: {
        uploading: Mutation<StateType>
    },
    actions: {
        changeLoading: Action<StateType,StateType>
    } 
}

const initState: StateType = {
    loading: false
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'loading',
    state: {
        ...initState
    },
    mutations: {
        uploading(state,payload){
            state.loading = payload
        }
    },
    actions: {
        changeLoading({commit},payload){
            commit('uploading',payload)
        }
    }
}

export default StoreModel
